export default __webpack_public_path__ + "static/media/مونا عبدی.b7f5a300.jpeg";